import _get from 'lodash-es/get';
import persons from './persons';
import educationServices from './education-services';
import companies from './companies';
import customerSupport from './customer-support';
import issues from './issues';

const constants = {
  persons,
  educationServices,
  issues,
  companies,
  customerSupport,
};

export default constants;

export function getConstant(value: string | string[], defaultValue = null): any {
  return _get(constants, value, defaultValue);
}
